import { css } from 'styled-components';

export default () => css`margin-bottom: 1rem;`;
